<template>
      <div no-body class="lku-apinv"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else >
        <b-col lg="12">
            <b-input-group >
                <b-input-group-prepend><label >Vendor</label></b-input-group-prepend>
                <b-form-input v-model="tblData.vendor" placeholder="Name" :disabled="((vendorcode||'') !== '')" @keyup.13.native="refresh()"></b-form-input>
                        <b-input-group-prepend><span class="mt-2" >Description</span></b-input-group-prepend>                  
                        <b-form-input v-model="tblData.uraian" @keyup.13.native="refresh()" placeholder="Description"></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Invoice Number </label></b-input-group-prepend>
                  <b-form-input v-model="tblData.invoice" @keyup.13.native="refresh()" placeholder="Invoice Number"></b-form-input>
                  <b-form-input v-model="tblData.nomor" @keyup.13.native="refresh()" placeholder="AP Number" class="ml-1"></b-form-input>
                <b-input-group-prepend><span class="pt-2 mr-1">Outstand.</span></b-input-group-prepend>
                <select  v-model="tblData.outstand"  style="width:60px;">
                    <option value="1">Yes</option><option value="0">No</option><option value="">-ALL-</option>
                </select>
                <b-input-group-append>
                    <b-button class="btn btn-success ml-3" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear </b-button>
                </b-input-group-append>
                
            </b-input-group>
        </b-col>

      </b-row>
        <b-table
          class="mb-0"
          ref="tblApinvOst" style="font-size:smaller;" 
          responsive small striped hover
          :items="tblData.items"
          :fields="fields"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="updatetable" 
          @row-clicked="selectItem"
        >
        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DDMMMYYYY") }}
        </template>
          <template v-slot:cell(totalinv)="data">
              {{data.item.totalinv | numFormat}}
          </template>

          <template v-slot:cell(outstand)="data">
            {{data.item.outstand | numFormat}}
          </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="tblData.limit"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>
<style lang="scss">
  .lku-apinv {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
    .input-group-prepend {
        label {
            padding-top: 5px;
            padding-right: 5px;
            width: 100px;
        }
    }

  }
</style>

<script>
import apinv from "../../apis/apinv";

export default {
  data() {
    return {
      lkuLoading:false,
      fields: [
          {
            key: "nomor",
            thStyle: "width:100px",
            label: "AP. Number",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:80px",
            label: "AP. Date",
            sortable: true
          },
          {
            key: "vendorinfo",
            label: "Vendor/Supplier",
            thStyle: "width:220px",
            sortable: true
          },
          {
            key: "invoice",
            thStyle: "width:120px",
            label: "Invoice #",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description",
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "totalinv",
            label: "Invoice Amount",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "outstand",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right"
          },
      ],
      tblData: {
        items:[],
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'tanggal',
        sortDesc: true,
        vendorcode:'',
        outstand : '1'
      },
      updatetable:false
    };
  },
  computed: {
    filterVendor() {
      return this.tblData.vendor;
    },
    filtervendorcode() {
      return this.tblData.vendorcode;
    },
    pagechange() {
      return this.tblData.page;
    },
    limitchange() {
      return this.tblData.limit;
    },
  },
  watch: {
    filterVendor: function(newval) {
      this.$emit('update:vendor', newval);
    },    
    filtervendorcode: function(newval) {
      this.$emit('update:vendorcode', newval);
    },   
    pagechange: function(newval) {
      this.tblData.page=newval;
      this.refresh();
    },   
    limitchange: function(newval) {
      this.data();
    },   
    "tblData.sortBy": function(newval) {
      this.data();
    },   
    "tblData.sortDesc": function(newval) {
      this.data();
    },   
  },
  props: ["vendor", "vendorcode","formdata","posted"],
  created: async function() {
      this.tblData.vendor=this.vendor || '';
      this.tblData.vendorcode=this.vendorcode || '';
      this.tblData.vendor=this.vendor || '';
      this.tblData.posting= this.posted || '';
      if (this.vendorcode) {
        if (this.formdata.items)
        {
          if (this.formdata.items[0].vendor!==this.vendorcode) {
            this.data();
          } else {
            for (var key in this.formdata) {
                this.tblData[key] = this.formdata[key];
            }
          }
        } else {
          this.data();
        }
      } else {
        if (this.formdata.items)
        {
            for (var key in this.formdata) {
                this.tblData[key] = this.formdata[key];
            }
        }
      }
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading=true;
      const list = await apinv.list(this.tblData);      
      this.lkuLoading=false;
      this.tblData.items=list;
      this.updatetable=!this.updatetable;
      // console.log('this.tblData : ',this.tblData);
    },
    selectItem(item,index) {
      // this.$emit("click", item);
      this.tblData.selected=item;
      this.$emit("click", this.tblData);
    },
    clearFilter() {
        this.tblData.vendor= '';
        this.tblData.vendorcode=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.invoice='';
    },    
    keymonitor: function(event) {
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblApinvOst.refresh();
       }
    },    
    refresh() {
      this.data();
      this.$refs.tblApinvOst.refresh();
    }
  }
};
</script>
